import { BaseService } from './BaseService';
import { PartnerScopedInput, PartnerMemberScopedInput } from '@/types/graphql/schemaTypes';
import upsertPartner from '@/graphql/mutations/partner/UpsertPartner.gql';
import deletePartner from '@/graphql/mutations/partner/DeletePartner.gql';
import createPartnerMember from '@/graphql/mutations/partner/CreatePartnerMember.gql';
import deletePartnerMember from '@/graphql/mutations/partner/DeletePartnerMember.gql';
import updatePartnerMember from '@/graphql/mutations/partner/UpdatePartnerMember.gql';

class PartnerService extends BaseService {
  public deletePartner(partnerId: string) {
    return this.client.mutate({
      mutation: deletePartner,
      variables: {
        partnerId
      }
    });
  }

  public upsertPartner(partnerArgs: PartnerScopedInput, partnerId?: string) {
    return this.client.mutate({
      mutation: upsertPartner,
      variables: {
        partnerArgs,
        partnerId
      }
    });
  }

  public createPartnerMember(membersArgs: PartnerMemberScopedInput[], partnerId: string) {
    return this.client.mutate({
      mutation: createPartnerMember,
      variables: {
        membersArgs,
        partnerId
      }
    });
  }

  public deletePartnerMember(memberId: string) {
    return this.client.mutate({
      mutation: deletePartnerMember,
      variables: {
        memberId
      }
    });
  }

  public updatePartnerMember(memberArgs: PartnerMemberScopedInput, memberId: string) {
    return this.client.mutate({
      mutation: updatePartnerMember,
      variables: {
        memberArgs,
        memberId
      }
    });
  }
}

export const partnerService = new PartnerService();
